import Spinner from "../../../../Components/Loader/Spinner";
import Table from "../../../../Components/Table/Table";

export default function OrdersList({
  rows,
  cancelingOrderId,
  onCancel,
  onEdit,
}) {
  return (
    <div className="hidden min-h-0 flex-1 mb:flex-initial mb:flex mb:flex-col">
      <Table
        isLTR={true}
        haveScroll={true}
        maxHeight="260px"
        columns={[
          { key: "date", label: "زمان ثبت" },
          { key: "symbol", label: "نماد" },
          { key: "side", label: "ساید" },
          { key: "type", label: "نوع" },
          { key: "stopPrice", label: "قیمت توقف" },
          { key: "orderPrice", label: "قیمت سفارش" },
          { key: "totalCost", label: "حجم" },
          { key: "takeProfit", label: "حد سود" },
          { key: "stopLoss", label: "حد ضرر" },
          {
            key: "operation",
            label: "عملیات",
            render: (value, row) =>
              value && (
                <div className="justify-center items-center flex gap-5 [direction:ltr]">
                  <button
                    type="button"
                    onClick={() => onCancel(row.id)}
                    disabled={cancelingOrderId === String(row.id)}
                    className={`min-w-8 inline-flex justify-center disabled:cursor-wait ${
                      cancelingOrderId === String(row.id)
                        ? ""
                        : "underline underline-offset-2 text-amber-400 hocus:underline-offset-8"
                    }`}
                  >
                    {cancelingOrderId === String(row.id) ? (
                      <Spinner size="20" color="#fbbf24" stroke="3" />
                    ) : (
                      "لغو"
                    )}
                  </button>
                  <button
                    type="button"
                    className="underline underline-offset-2 hocus:underline-offset-8"
                    onClick={() => onEdit(row)}
                  >
                    ویرایش
                  </button>
                </div>
              ),
          },
        ]}
        data={rows}
      />
    </div>
  );
}
